import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { TasksBodyComponent } from './container-tasks/tasks-body/tasks-body.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpecificTaskComponent } from './specific-task/specific-task.component';
import { TaskDetailComponent } from './specific-task/tasks-details/task-detail.component';
import { TasksPropertiesComponent } from './specific-task/tasks-details/tasks-properties/tasks-properties.component';
import { TasksTabsComponent } from './specific-task/tasks-details/tasks-tabs/tasks-tabs.component';
import {
  TasksDetailsCharacteristicsComponent
} from './specific-task/tasks-details/tasks-tabs/tasks-details-characteristics/tasks-details-characteristics.component';
import { TasksDetailsScaiComponent } from './specific-task/tasks-details/tasks-tabs/tasks-details-scai/tasks-details-scai.component';

import {
  TasksDetailsCommentsComponent
} from './specific-task/tasks-details/tasks-tabs/tasks-details-comments/tasks-details-comments.component';

import { PropertiesContentComponent } from './specific-task/tasks-details/tasks-properties/properties-content/properties-content.component';
import { ErrorPropertiesComponent } from './specific-task/tasks-details/tasks-properties/error-properties/error-properties.component';
import {
  BusinessPropertiesComponent
} from './specific-task/tasks-details/tasks-properties/business-properties/business-properties.component';
import { ClientPropertiesComponent } from './specific-task/tasks-details/tasks-properties/client-properties/client-properties.component';
import { TaskPropertiesComponent } from './specific-task/tasks-details/tasks-properties/task-properties/task-properties.component';


import {
  MassiveModeComponent
} from './container-tasks/tasks-body/massive-mode-popup/massive-mode.component';
import { LimitExcededPopupComponent } from './container-tasks/tasks-body/limit-exceded-popup/limit-exceded-popup.component';
import { MyTaskComponent} from './container-tasks/tasks-body/my-tasks-popup/my-tasks.component';
import { MyUnassignedTaskComponent } from './container-tasks/tasks-body/my-unassigned-tasks-popup/my-unassigned-tasks.component';

import { TasksDetailsBillingComponent } from './specific-task/tasks-details/tasks-tabs/tasks-details-billing/tasks-details-billing.component';
import { SearchTasksComponent } from './container-tasks/search-tasks.component';
import { BypassComponent } from './specific-task/tasks-details/tasks-tabs/tasks-details-characteristics/bypass/bypass.component';
import { RelaunchComponent } from './specific-task/tasks-details/tasks-tabs/tasks-details-characteristics/relaunch/relaunch.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MaterialModule } from 'src/app/modules/material.module';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material';

@NgModule({
  declarations: [
    SearchTasksComponent, TasksBodyComponent,
    SpecificTaskComponent, TaskDetailComponent, TasksPropertiesComponent, TasksTabsComponent,
    TasksDetailsCharacteristicsComponent,
    TasksDetailsScaiComponent,
    TasksDetailsCommentsComponent,
    PropertiesContentComponent,
    ErrorPropertiesComponent,
    BusinessPropertiesComponent,
    ClientPropertiesComponent,
    TaskPropertiesComponent,
    MassiveModeComponent,
    LimitExcededPopupComponent,
    TasksDetailsBillingComponent,
    RelaunchComponent,
    BypassComponent,
    MassiveModeComponent,
    MyTaskComponent,
    MyUnassignedTaskComponent],

  imports: [
    PipesModule,
    CommonModule,
    SharedModule,
    CoreModule,
    MaterialModule,
    RouterModule,
    MatExpansionModule
  ],
  entryComponents: [
    RelaunchComponent,
    BypassComponent,
    MassiveModeComponent,
    MyTaskComponent,
    MyUnassignedTaskComponent
  ],
  exports: [
    SearchTasksComponent,
    SpecificTaskComponent
  ]
})
export class TasksModule { }